/**
 * Replace zero to the corresponding letter:
 * B - billions
 * M - millions
 * K - thousands
 * useful for events bound to scroll and resize events
 * @param  {Integer} val    Number which needs reducing
 * @return {String}
 */

const reduceNumber = (val, power) => {
    let reducedNum = val / Math.pow(10, power);
    if (reducedNum % 1 == 0) {
        return reducedNum;
    } else {
        return reducedNum.toFixed(1);
    }
};

const zeroReducer = val => {
    let res = `${val}`;
    if (val / Math.pow(10, 9) >= 1) {
        res = `${reduceNumber(val, 9)}B`;
    } else if (val / Math.pow(10, 6) >= 1) {
        res = `${reduceNumber(val, 6)}M`;
    } else if (val / Math.pow(10, 3) >= 1) {
        res = `${reduceNumber(val, 3)}K`;
    }
    return res;
};

export default zeroReducer;
